import api from '../services/api.service';
import { API_ROUTES } from '../constants/apiRoutes';
import { extractData } from '../utils/helpers/extractDataHelper';

const schema = {
  addFavoriteProject: async (params = {}) => {
    try {
      const response = await api.post(`${API_ROUTES.FAVORITE_PROJECTS}${params}`);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  removeFavoriteProject: async (params = {}) => {
    try {
      const response = await api.destroy(`${API_ROUTES.FAVORITE_PROJECTS}${params}`);
      return extractData(response);
    } catch (error) {
      return error;
    }
  },
  getImportantTasksByProjectRequest: async (projectId, params = {}) => {
    try {
      const response = await api.get(`/projects/${projectId}/tasks`, params);
      return extractData(response);
    } catch (error) {
      return error;
    }
  }
};

export default schema;
